<template>
    <ProspectHeader :showLabel="true" cssClass="content-type-35" />
    <component
        v-for="widget in widgets"
        :key="widget.id"
        :is="widget.component"
        v-bind="widget.props"
        :ref="el => registerComponentRef(widget.id, el)"
    />
</template>

<script>
    import ProspectHeader from '@/components/prospect/widgets/ProspectHeader';
    import ProspectAiWidget from '@/components/prospect/widgets/ProspectAiWidget';
    import ProspectFirmology from '@/components/prospect/widgets/ProspectFirmology';
    import ProspectContactInfo from '@/components/prospect/widgets/ProspectContactInfo';
    import ProspectOpeningHours from '@/components/prospect/widgets/ProspectOpeningHours';
    import ProspectIndustries from '@/components/prospect/widgets/ProspectIndustries';
    import ProspectReviewsSummary from '@/components/prospect/widgets/ProspectReviewsSummary';
    import ProspectSiteSearch from '@/components/prospect/widgets/ProspectSiteSearch';
    import ProspectPeople from '@/components/prospect/widgets/ProspectPeople';
    import ProspectFamily from '@/components/prospect/widgets/ProspectFamily';
    import ProspectProperty from '@/components/prospect/widgets/ProspectProperty';
    import ProspectSameAddress from '@/components/prospect/widgets/ProspectSameAddress';
    import ProspectReviewsDetails from '@/components/prospect/widgets/ProspectReviewsDetails';
    import ProspectNews from '@/components/prospect/widgets/ProspectNews';
    import ProspectVacancies from '@/components/prospect/widgets/ProspectVacancies';
    import ProspectAppsDetails from '@/components/prospect/widgets/ProspectAppsDetails';
    import ProspectSiteRank from '@/components/prospect/widgets/ProspectSiteRank';
    import ProspectContacts from '@/components/prospect/widgets/ProspectContacts';
    import ProspectSessions from '@/components/prospect/widgets/ProspectSessions';
    import ProspectTags from '@/components/prospect/widgets/ProspectTags';
    import ProspectAssignment from '@/components/prospect/widgets/ProspectAssignment';
    import ProspectEvents from '@/components/prospect/widgets/ProspectEvents';
    import { useCompanyWidgetsStore } from '@/stores/companyWidgets';

    export default {
        name: "CompanyDetails",
        components: {
            ProspectHeader,
            ProspectAiWidget,
            ProspectFirmology,
            ProspectContactInfo,
            ProspectOpeningHours,
            ProspectIndustries,
            ProspectReviewsSummary,
            ProspectSiteSearch,
            ProspectPeople,
            ProspectFamily,
            ProspectProperty,
            ProspectSameAddress,
            ProspectReviewsDetails,
            ProspectNews,
            ProspectVacancies,
            ProspectAppsDetails,
            ProspectSiteRank,
            ProspectContacts,
            ProspectSessions,
            ProspectTags,
            ProspectAssignment,
            ProspectEvents
        },
        computed: {
            widgets() {
                return useCompanyWidgetsStore().getWidgets();
            }
        },
        methods: {
            registerComponentRef(id, el) {
                if (el) {
                    useCompanyWidgetsStore().registerComponentRef(id, el ?? null);
                }
            }
        },
        unmounted() {
            useCompanyWidgetsStore().resetWidgetStore();
        }
    }
</script>